import { ValidationErrors, UntypedFormControl } from '@angular/forms';

export const PasswordValidation = {
  containsUpperCase: containsUpperCase,
  containsLowerCase: containsLowerCase,
  containsDigit: containsDigit,
  containsSpecialChar: containsSpecialChar,
};

function containsUpperCase(control: UntypedFormControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return /\p{Lu}/u.test(control.value) ? null : { missingUpperCase: true };
}

function containsLowerCase(control: UntypedFormControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return /\p{Ll}/u.test(control.value) ? null : { missingLowerCase: true };
}

function containsDigit(control: UntypedFormControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return /\d/.test(control.value) ? null : { missingDigit: true };
}

function containsSpecialChar(control: UntypedFormControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return /[^\p{L}\d\s]/u.test(control.value)
    ? null
    : { missingSpecialChar: true };
}
